import {Injectable, signal} from '@angular/core';
import {ProjectDetailResponse} from '@frontend/shared-api';

@Injectable({
  providedIn: 'root',
})
export class ProjectDataService {
  private readonly projectData = signal<ProjectDetailResponse | null>(null);

  setProject(project: ProjectDetailResponse): void {
    this.projectData.set(project);
  }

  clearProject(): void {
    this.projectData.set(null);
  }

  getProject() {
    return this.projectData;
  }

  getOffices() {
    return this.projectData()?.offices || [];
  }

  getProjectId(): number | null {
    const project = this.projectData();
    return project?.id ?? null;
  }
}
